var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-' + _vm.field.component,{tag:"component",attrs:{"field":_vm.field,"model":_vm.model,"errors":_vm.errors,"event-bus":_vm.$events,"layout":_vm.layout},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }